import apiClient from './api'

class SizeGuideService {
  /**
   * Get size guide by category type ID
   * @param {number} categoryTypeId
   * @returns {Promise<Array>}
   */
  async getSizeGuide(categoryTypeId) {
    if (!categoryTypeId) {
      throw new Error('Category Type ID is required')
    }
    const response = await apiClient.get(`/SizeGuides/${categoryTypeId}`)
    return response.data
  }
}

export const sizeGuideService = new SizeGuideService()
